"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _faCheck = require("@fortawesome/free-solid-svg-icons/faCheck");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _button = require("baseui/button");

var _react = _interopRequireWildcard(require("react"));

var _constants = require("./constants");

var _style = require("./style");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * This is a basic Button component. It's a thin wrapper around the
 * [baseui button](https://baseweb.design/components/button/), so it
 * supports many of the same props.
 */
const Button = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    disabled = false,
    isLoading = false,
    isSuccess = false,
    kind = _constants.Kind.PRIMARY,
    size = _constants.Size.STANDARD,
    overrides,
    successComponent,
    type = 'button',
    ...buttonProps
  } = props;
  const isDisabled = disabled || isSuccess || isLoading; // The success check mark is just a replaced loading spinner
  // This lets us lean on baseui to keep the width the same etc.

  const Success = () => successComponent || /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faCheck.faCheck
  });

  const LoadingSpinner = isSuccess ? Success : {
    style: styleArgs => ({ ...(0, _style.getLoadingSpinnerColorStyle)(kind, styleArgs),
      ...(0, _style.getLoadingSpinnerSizeStyle)(size)
    })
  };
  const disabledOverride = isSuccess || isLoading;
  return /*#__PURE__*/_react.default.createElement(_button.Button, _extends({
    ref: ref,
    type: type,
    disabled: isDisabled,
    isLoading: isLoading || isSuccess,
    overrides: {
      BaseButton: {
        style: styleArgs => {
          return { ...(0, _style.getBaseStyle)(styleArgs),
            ...(0, _style.getColorStyle)(kind, styleArgs, disabledOverride),
            ...(0, _style.getSizeStyle)(size)
          };
        }
      },
      EndEnhancer: {
        style: (0, _style.getEndEnhancerStyle)(size)
      },
      StartEnhancer: {
        style: (0, _style.getStartEnhancerStyle)(size)
      },
      LoadingSpinnerContainer: {
        style: (0, _style.getSpinnerContainerStyle)()
      },
      LoadingSpinner,
      ...(overrides || {})
    }
  }, buttonProps));
});
Button.displayName = 'Button';
var _default = Button;
exports.default = _default;